import { Button, type ButtonProps } from '@mui/material';
import { type ComposerSendButtonOwnerState, useChatActions } from '@mui/x-chat/headless';
import { StopCircleIcon } from '@phosphor-icons/react';

import { isTruthy } from 'common';

type AgenticChatSendButtonProps = ButtonProps & { ownerState?: ComposerSendButtonOwnerState };

export function AgenticChatSendButton(props: AgenticChatSendButtonProps) {
  const { ownerState, ...buttonProps } = props;
  const chatActions = useChatActions();

  if (isTruthy(ownerState?.isStreaming)) {
    return (
      <Button
        {...buttonProps}
        // MUI Chat alpha.16 forces the send button disabled while streaming; stopping must stay live.
        disabled={false}
        type="button"
        variant="outlined"
        color="inherit"
        aria-label="Stop generating"
        startIcon={<StopCircleIcon size={16} aria-hidden />}
        onClick={() => chatActions.stopStreaming()}
      >
        Stop
      </Button>
    );
  }

  return (
    <Button {...buttonProps} variant="contained">
      Send
    </Button>
  );
}
